module.exports = __webpack_public_path__ + "img/26_158.cfb93140.png";